/**
 * 🏭 TIER 6 BUILDINGS - Industry
 * 
 * Unlocked by: Engineering, Steel Production, Industrialization, etc.
 * Cost multiplier: 97.7x | Prod multiplier: 10.5x
 * Costs: 5,000-12,000 | Production: 4-5.5/s
 * Target ROI: ~8 minutes
 */

export const TIER_06_BUILDINGS = {
  workshop: {
    id: 'workshop',
    name: 'Workshop',
    icon: '🔨',
    tier: 6,
    description: 'Crafts complex tools',
    flavor: 'Skilled hands shape the future.',
    baseCost: { wood: 6000, stone: 4000, iron: 3200 },
    baseProduction: { tools: 4.2 },
    unlockCondition: { tech: 'engineering' },
  },

  steelMill: {
    id: 'steelMill',
    name: 'Steel Mill',
    icon: '🏭',
    tier: 6,
    description: 'Refines iron into steel',
    flavor: 'Fire and iron become steel.',
    baseCost: { stone: 8000, iron: 6000, coal: 2000 },
    baseProduction: { steel: 3.2 },
    unlockCondition: { tech: 'steel_production' },
  },

  factory: {
    id: 'factory',
    name: 'Factory',
    icon: '🏭',
    tier: 6,
    description: 'Mass produces goods',
    flavor: 'The heartbeat of industry.',
    baseCost: { stone: 12000, steel: 4000, coal: 3200 },
    baseProduction: { tools: 5.5, machinery: 2.0 },
    unlockCondition: { tech: 'industrialization' },
  },

  powerPlant: {
    id: 'powerPlant',
    name: 'Power Plant',
    icon: '⚡',
    tier: 6,
    description: 'Generates energy from coal',
    flavor: 'Harnessing the power of fire.',
    baseCost: { stone: 16000, steel: 8000, coal: 6000 },
    baseProduction: { energy: 5.0 },
    unlockCondition: { tech: 'power_generation' },
  },

  coalMine: {
    id: 'coalMine',
    name: 'Coal Mine',
    icon: '⚫',
    tier: 6,
    description: 'Extracts coal for fuel',
    flavor: 'Black gold fuels progress.',
    baseCost: { stone: 7200, iron: 4000 },
    baseProduction: { coal: 5.0 },
    unlockCondition: { tech: 'coal_mining' },
  },
};

export default TIER_06_BUILDINGS;
